import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'
import Vue from 'vue'
import {router} from "@/router";

const DIR = 'publishing/income'

const DEFAULT_INLINE_EDITING_VALUES = {
    abbreviation: null,
    showListNumber: false,
    commissionPercent: null, 
    conversionFactor: null,
    listNumber: null,
    period: {
        num: null,
        period: "notDefined",
        year: null
    }    
}

const state = {
// List
    income: [],
    selectedIncome: [],
    isAllSelectedIncome: false,
    expandedIncome: [],
    incomeImporters: [],
    incomeInlineEditingDialogDetails: {},
    incomeInlineEditingDialogDefault: DEFAULT_INLINE_EDITING_VALUES,
    incomeServerSideSortingOptions:{
        sortBy: ['importDate'],
        sortDesc: [true],
        mustSort: true
    },

// Filters
    incomeSearch: '',
    selectedIncomeHalfYearFilter: null,
    selectedIncomeFromQuarter: null,
    selectedIncomeToQuarter: null,
    selectedIncomeFromYear: null,
    selectedIncomeToYear: null,

// Actions (Buttons, Import, Export)
    selectedIncomeAction: [],
    incomeDetailsSelectedCompany:[],
    publishingIncomeDetails: null,
    publishingIncomeDetailsImportCurrencyConversionFactor: null,
    publishingIncomeDetailsImportCommissionPercent: null,

// Details (Read Only => Error List)
    incomeDetails: {},
    incomeErrorListSelectedErrorCodes: [],
    showFixItDialog: false,
    showFixItSF102Dialog: false,
    showFixItC3ErrorDialog: false,
    showFixItRecipientDialog: false,
    worksForFixItSearch: null,
    fixItYktoOptions: [],
    fixItYktoSelected: null,
    fixItErrorObject: null,
    fixItSF102ErrorObject: null,
    fixItC3ErrorObject: null,
    fixItRecipientErrorObject: null,
    fixItRecipientDetailsNewRecipient: null,
    fixItRecipientNewRecipientOptions: [],
    incomeErrorListFixItSF102DetailsCountry: null,

    // Error code list
    incomeErrorCodes: [],

    // AI analysis dialog (KI-Analyse für Fehlerzeilen)
    showIncomeErrorAiAnalysisDialog: false,
    incomeErrorAiAnalysisLoading: false,
    incomeErrorAiAnalysisResult: '',
    incomeErrorAiAnalysisError: '',
}

const getters = {
// List
    getIncome(state) { return state.income },

    getSelectedIncome(state) { return state.selectedIncome },
    getIsAllSelectedIncome(state) { return state.isAllSelectedIncome },
    getExpandedIncome(state) { return state.expandedIncome },
    getIncomeServerSideSortingOptions(state){ return state.incomeServerSideSortingOptions },

    getIncomeImporters(state) {return state.incomeImporters},

    // Inline Editing Dialog
    getIncomeInlineEditingDialogDefault                         (state) { return state.incomeInlineEditingDialogDefault },
    getIncomeInlineEditingDialogDetails                         (state) { return state.incomeInlineEditingDialogDetails },
    getIncomeInlineEditingDialogDetailsListNo                   (state) { return state.incomeInlineEditingDialogDetails.listNumber },
    getIncomeInlineEditingDialogDetailsConversionFactor         (state) { return state.incomeInlineEditingDialogDetails.conversionFactor },
    getIncomeInlineEditingDialogDetailsCommissionPercent        (state) { return state.incomeInlineEditingDialogDetails.commissionPercent },
    
    // Period
    getSelectedPeriodValuesIncomeInlineEditingDialog            (state) { return state.incomeInlineEditingDialogDetails.period },
    getSelectedPeriodNumberIncomeInlineEditingDialog            (state) { return state.incomeInlineEditingDialogDetails.period.num },
    getSelectedPeriodTimeUnitIncomeInlineEditingDialog          (state) { return state.incomeInlineEditingDialogDetails.period.period },
    getSelectedPeriodYearIncomeInlineEditingDialog              (state) { return state.incomeInlineEditingDialogDetails.period.year },
    
// Filters
    getIncomeSearch                                             (state) { return state.incomeSearch },
    getSelectedIncomeHalfYearFilter                              (state) { return state.selectedIncomeHalfYearFilter },
    getSelectedIncomeFromQuarter                                (state) { return state.selectedIncomeFromQuarter },
    getSelectedIncomeToQuarter                                  (state) { return state.selectedIncomeToQuarter },
    getSelectedIncomeFromYear                                   (state) { return state.selectedIncomeFromYear },
    getSelectedIncomeToYear                                     (state) { return state.selectedIncomeToYear },

// Actions (Buttons, Import, Export)
    getSelectedIncomeAction(state) { return state.selectedIncomeAction },
    getPublishingIncomeDetailsImportCurrencyConversionFactor    (state) { return state.publishingIncomeDetailsImportCurrencyConversionFactor },
    getPublishingIncomeDetailsImportCommissionPercent           (state) { return state.publishingIncomeDetailsImportCommissionPercent },
    
    getIncomeDetailsSelectedCompany                             (state) { return state.incomeDetailsSelectedCompany },
// Details (Read Only => Error List)
    getIncomeDetails                                            (state) { return state.incomeDetails },
    getIncomeErrorListSelectedErrorCodes                        (state) { return state.incomeErrorListSelectedErrorCodes },
    getShowFixItDialog                                          (state) { return state.showFixItDialog },
    getShowFixItSF102Dialog                                     (state) { return state.showFixItSF102Dialog },
    getShowFixItC3ErrorDialog                                   (state) { return state.showFixItC3ErrorDialog },
    getShowFixItRecipientDialog                                 (state) { return state.showFixItRecipientDialog },
    getWorksForFixItSearch                                      (state) { return state.worksForFixItSearch },
    getFixItYktoOptions                                         (state) { return state.fixItYktoOptions },
    getFixItDetailsYkto                                         (state) { return state.fixItYktoSelected },
    getFixItErrorObject                                         (state) { return state.fixItErrorObject },
    getFixItSF102ErrorObject                                    (state) { return state.fixItSF102ErrorObject },
    getFixItC3ErrorObject                                       (state) { return state.fixItC3ErrorObject },
    getFixItRecipientErrorObject                                (state) { return state.fixItRecipientErrorObject },
    getFixItRecipientDetailsNewRecipient                        (state) { return state.fixItRecipientDetailsNewRecipient },
    getFixItRecipientNewRecipientOptions                        (state) { return state.fixItRecipientNewRecipientOptions },
    getIncomeErrorListFixItSF102DetailsCountry                  (state) { return state.incomeErrorListFixItSF102DetailsCountry },

    // new for AKM abbreviations (model for others?)
    getPublishingIncomeDetailsAbbreviation                      (state) { return state.incomeInlineEditingDialogDetails.abbreviation },

    // Error code list
    getIncomeErrorCodes(state)                                  { return state.incomeErrorCodes },

    // AI analysis dialog
    getShowIncomeErrorAiAnalysisDialog(state)                   { return state.showIncomeErrorAiAnalysisDialog },
    getIncomeErrorAiAnalysisLoading(state)                      { return state.incomeErrorAiAnalysisLoading },
    getIncomeErrorAiAnalysisResult(state)                       { return state.incomeErrorAiAnalysisResult },
    getIncomeErrorAiAnalysisError(state)                        { return state.incomeErrorAiAnalysisError },
}

const mutations = {
// List
    setIncome:                                                  (state, incomeFromDB) => { state.income = incomeFromDB },
    setSelectedIncome:                                          (state, selectedIncome) => { state.selectedIncome = selectedIncome },
    setIsAllSelectedIncome:                                     (state, isSelected) => { state.isAllSelectedIncome = isSelected },
    setExpandedIncome:                                          (state, income) => {
                                                                if(Object.keys(income).length === 0) state.expandedIncome = []
                                                                else state.expandedIncome = [income] 
                                                            },
    setIncomeServerSideSortingOptions:                          (state, value) => { state.incomeServerSideSortingOptions = value },

    // Inline Editing Dialog
    setIncomeInlineEditingDialogDefault:                        (state) => { state.incomeInlineEditingDialogDefault = DEFAULT_INLINE_EDITING_VALUES },
    setIncomeInlineEditingDialogDetails:                        (state, details) => { state.incomeInlineEditingDialogDetails = details },
    setIncomeInlineEditingDialogDetailsListNo:                  (state, number) => { state.incomeInlineEditingDialogDetails.listNumber = number },
    setIncomeInlineEditingDialogDetailsConversionFactor:        (state, factor) => { state.incomeInlineEditingDialogDetails.conversionFactor = factor },
    setIncomeInlineEditingDialogDetailsCommissionPercent:       (state, percent) => { state.incomeInlineEditingDialogDetails.commissionPercent = percent },

    setIncomeImporters:                                         (state, importers) => {state.incomeImporters = importers},

    // Period
    setSelectedPeriodValuesIncomeInlineEditingDialog:           (state, values) => { state.incomeInlineEditingDialogDetails.period = values },
    setSelectedPeriodNumberIncomeInlineEditingDialog:           (state, number) => { state.incomeInlineEditingDialogDetails.period.num = number },
    setSelectedPeriodTimeUnitIncomeInlineEditingDialog:         (state, unit) => { state.incomeInlineEditingDialogDetails.period.period = unit },
    setSelectedPeriodYearIncomeInlineEditingDialog:             (state, year) => { state.incomeInlineEditingDialogDetails.period.year = year },
    

    // Filters
    setIncomeSearch: (state, search) => { state.incomeSearch = search },
    setSelectedIncomeHalfYearFilter: (state, value) => {
        state.selectedIncomeHalfYearFilter = value
        const [year, halfYear] = typeof value === 'string' ? value.split('-') : [null, null]
        state.selectedIncomeFromQuarter = halfYear === '1' ? 1 : halfYear === '2' ? 3 : null
        state.selectedIncomeToQuarter = halfYear === '1' ? 2 : halfYear === '2' ? 4 : null
        state.selectedIncomeFromYear = year ? Number(year) : null
        state.selectedIncomeToYear = year ? Number(year) : null
    },
    setSelectedIncomeFromQuarter: (state, value) => { state.selectedIncomeFromQuarter = value },
    setSelectedIncomeToQuarter: (state, value) => { state.selectedIncomeToQuarter = value },
    setSelectedIncomeFromYear: (state, value) => { state.selectedIncomeFromYear = value },
    setSelectedIncomeToYear: (state, value) => { state.selectedIncomeToYear = value },

    // Actions (Buttons, Import, Export)
    setSelectedIncomeAction: (state, selectedAction) => { state.selectedIncomeAction = selectedAction },
    setPublishingIncomeDetailsImportCurrencyConversionFactor:   (state, value) => { state.publishingIncomeDetailsImportCurrencyConversionFactor = value },
    setPublishingIncomeDetailsImportCommissionPercent:          (state, value) => { state.publishingIncomeDetailsImportCommissionPercent = value },
    
// new for AKM abbreviations (model for others?)
setPublishingIncomeDetailsAbbreviation:                     (state, value) => { state.incomeInlineEditingDialogDetails.abbreviation = value },
    
    setIncomeDetailsSelectedCompany:                            (state, value) => { state.incomeDetailsSelectedCompany = value },

    // Details (Read Only => Error List)
    setIncomeDetails:                                           (state, value) => { state.incomeDetails = value },
    setIncomeErrorListSelectedErrorCodes:                       (state, value) => { state.incomeErrorListSelectedErrorCodes = value },
    setShowFixItDialog:                                         (state, value) => { state.showFixItDialog = value},
    setShowFixItSF102Dialog:                                    (state, value) => { state.showFixItSF102Dialog = value},
    setShowFixItC3ErrorDialog:                                  (state, value) => { state.showFixItC3ErrorDialog = value},
    setShowFixItRecipientDialog:                                (state, value) => { state.showFixItRecipientDialog = value},
    setWorksForFixItSearch:                                     (state, value) => { state.worksForFixItSearch = value},
    setFixItYktoOptions:                                        (state, value) => { state.fixItYktoOptions = value },
    setFixItDetailsYkto:                                        (state, value) => { state.fixItYktoSelected = value },
    setFixItErrorObject:                                        (state, value) => { state.fixItErrorObject = value },
    setFixItSF102ErrorObject:                                   (state, value) => { state.fixItSF102ErrorObject = value },
    setFixItC3ErrorObject:                                      (state, value) => { state.fixItC3ErrorObject = value },
    setFixItRecipientErrorObject:                               (state, value) => { state.fixItRecipientErrorObject = value },
    setFixItRecipientDetailsNewRecipient:                       (state, value) => { state.fixItRecipientDetailsNewRecipient = value },
    setFixItRecipientNewRecipientOptions:                       (state, value) => { state.fixItRecipientNewRecipientOptions = value },
    setIncomeErrorListFixItSF102DetailsCountry:                 (state, value) => { state.incomeErrorListFixItSF102DetailsCountry = value },

    // Error code list
    setIncomeErrorCodes:                                        (state, value) => { state.incomeErrorCodes = value },

    // AI analysis dialog
    setShowIncomeErrorAiAnalysisDialog:                         (state, value) => { state.showIncomeErrorAiAnalysisDialog = value },
    setIncomeErrorAiAnalysisLoading:                            (state, value) => { state.incomeErrorAiAnalysisLoading = value },
    setIncomeErrorAiAnalysisResult:                             (state, value) => { state.incomeErrorAiAnalysisResult = value },
    setIncomeErrorAiAnalysisError:                              (state, value) => { state.incomeErrorAiAnalysisError = value },

    // Wipe FixIt / AI dialog flags when Income list unmounts so remount does not reopen stale dialogs
    resetIncomeFixItDialogs: (state) => {
        state.showFixItDialog = false
        state.showFixItSF102Dialog = false
        state.showFixItC3ErrorDialog = false
        state.showFixItRecipientDialog = false
        state.showIncomeErrorAiAnalysisDialog = false
        state.fixItErrorObject = null
        state.fixItSF102ErrorObject = null
        state.fixItC3ErrorObject = null
        state.fixItRecipientErrorObject = null
        state.incomeErrorAiAnalysisResult = ''
        state.incomeErrorAiAnalysisError = ''
        state.incomeErrorAiAnalysisLoading = false
    },
}

const actions = {
// FETCH INCOME
    async fetchIncome({ commit, getters }) {
        commit('setIsLoading', true)

        const selectedHalfYear = getters.getSelectedIncomeHalfYearFilter
        const [year, halfYear] = typeof selectedHalfYear === 'string' ? selectedHalfYear.split('-') : [null, null]

        // check for set filters
        let filterObj = {
            'search' :      getters.getIncomeSearch,
            'year':         year,
            'halfYear':     halfYear
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        // let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)   
        let options = getters.getIncomeServerSideSortingOptions
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)
       

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setIncome', [])
        } else { 
            commit('setIncome', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

// FETCH DETAILS => ERROR LISTS
    async fetchIncomeDetails({ commit, getters }, params) {
        const selectedErrorCodes = getters.getIncomeErrorListSelectedErrorCodes
        let queryParams = []
        let page = null
        let alvId = null

        if (typeof params === 'object') {
            alvId = params.alvId
            page = params.currentPage
        } else {
            alvId = params
        }
        
        if (selectedErrorCodes.length > 0) {
            queryParams.push('filter=errorCode[' + selectedErrorCodes.join(',') + ']')
        }
        if (page) {
            queryParams.push('page=' + page)
        }

        const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
        let response = await api.getDetailsById(DIR, alvId, '/errorList' + queryString)
        
        if(response.list.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        commit('setIncomeDetails', response)
        commit('setIsLoading', false)
    },

    async fetchIncomeImporters({commit}) {
        const response = await api.getIncomeImporters();
        // Only keep importers that have at least one mapping (deprecated importers are hidden)
        const items = response && response.response ? response.response : []
        const filtered = items.filter(item => item && item.mappings && Array.isArray(item.mappings) && item.mappings.length > 0)
        commit('setIncomeImporters', filtered)
    },

    async fetchErrorCodes({commit}) {
        const url = api.rootUrl + '/publishing/income/errorCodes'
        const response = await api.getResponse(url);
        commit('setIncomeErrorCodes', response ? response : [])
    },

// SAVE Edit row
    async saveIncomeEditDialog({ getters, dispatch, commit }) {
        let alvId = getters.getSelectedIncome

        let metaData = {
            "period"            : getters.getSelectedPeriodValuesIncomeInlineEditingDialog,
            "conversionFactor"  : (getters.getIncomeInlineEditingDialogDetailsConversionFactor == "" ? null : getters.getIncomeInlineEditingDialogDetailsConversionFactor),
            "commissionPercent" : (getters.getIncomeInlineEditingDialogDetailsCommissionPercent == "" ? null : getters.getIncomeInlineEditingDialogDetailsCommissionPercent),
            "listNumber"        : getters.getIncomeInlineEditingDialogDetailsListNo,
            // "abbreviation"      : getters.getPublishingIncomeDetailsAbbreviation,
        }

        let response = await api.saveEditForm(DIR, alvId, metaData)
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_PUBLISHING_INCOME_SUCCESS_SAVED')
            })
            dispatch('fetchIncome')
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
            })
        }
    },

// ACTIONS Switch

    async doFileImport({commit, dispatch, getters}) {
        if(router.currentRoute.name !== "Income") {
            return
        }
        const incomeOption = getters.getSelectedFileImport

        let tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') + ' fileType' + i18n.t('lang_GENERIC_CAPTION_FILE')  + '. <br />' +
            i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
        let dialogText = ''
        let found = null
        let name = ""

        let title = incomeOption.text

        // Build unique file formats from mappings; fallback to fileExtensions if mappings are missing
        let formatsArray = []
        if (incomeOption && incomeOption.mappings && Array.isArray(incomeOption.mappings) && incomeOption.mappings.length > 0) {
            formatsArray = incomeOption.mappings
                .map(m => m && m.fileFormat ? m.fileFormat.toString().toUpperCase() : null)
                .filter(v => v)
        }
        const formatsUnique = Array.from(new Set(formatsArray))
        const extensions = formatsUnique.join(' / ')

        tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD')
            + ' fileType. ' +
            i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')

        dialogText = tempText.replace(/fileType|<join>/gi, matched => {
            return {
                fileType: title+i18n.t('lang_GENERIC_CAPTION_FILE'),
                '<join>': extensions
            }[matched]
        })
        commit('setImportDialogText', dialogText)
        commit('setShowFileImportDialog', true)

    },

    async doIncomeAction({ commit, dispatch, getters }) {
        let selectedIncome = { "alvIds" : getters.getSelectedIncome }
        switch(state.selectedIncomeAction) {

            case 'runErrorLists':
                if(state.selectedIncome.length > 0) {
                    dispatch('runErrorLists', { dir: DIR, metaData: selectedIncome, context: "Income"})
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break

            case 'downloadErrorList':
                if(state.selectedIncome.length > 0) {
                    dispatch('downloadErrorLists', { dir: DIR, metaData: selectedIncome })
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break

            case 'compareGemaBew': 
                if(state.selectedIncome.length === 1) {
                    dispatch('compareGemaBew', { dir: DIR, metaData: selectedIncome })
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'move':
                if(state.selectedIncome.length > 0) {
                    commit('setShowMoveContractsDialog',true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)	
                }
                break

            case 'delete':
                if(state.selectedIncome.length > 0) {
                    commit('setShowDeletionDialog', true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)	
                }
                break
        }
    },

    // Action: DELETE
    async deleteSelectedIncome({ commit, getters, dispatch }) {
        const response = await api.deleteEntries(DIR, getters.getSelectedIncome)
        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedIncome.length; i++) {
                let index = getters.getIncome.findIndex(income => income.alvId == getters.getSelectedIncome[i])
                Vue.delete(getters.getIncome, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            commit('setSelectedIncome', [])
            commit('setSelectedIncomeAction', [])
            dispatch('fetchIncome')
        }
    },
    //Action : MOVE
    async moveSelectedIncome({ getters, commit, dispatch  }) {

        let metaData = { "alvIds" : getters.getSelectedIncome,
        
                        "company" : getters.getIncomeDetailsSelectedCompany }
        let queryParams = { "action": 'move'}
        const response = await api.triggerAction(DIR,metaData,queryParams)


        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_MOVED')
            })
        }
        
        commit('setSelectedIncome', [])
        commit("setIsAllSelectedIncome",false)
        commit('setSelectedIncomeAction', [])
        dispatch('fetchIncome')
    },

    // FIX-IT
    async fixIt({ commit, dispatch, getters }) {
        let metaData = { "error" : getters.getFixItErrorObject,
                        "newKto" : getters.getFixItDetailsYkto }
        let queryParams = { "action": 'fixIt'}
        const response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_FIX_IT_APPLIED')
            })
        }
        commit('setSelectedIncome', [])
        commit("setIsAllSelectedIncome",false)
        commit('setSelectedIncomeAction', [])
        dispatch('fetchIncome')
    },

    async fixItSF102({ commit, dispatch }, payload) {
        // Build the metadata from the payload with all five parameters.
        // Expected payload structure:
        // {
        //   otherId: "609571",
        //   sourceAlvId: "ALV000211902AG",
        //   country: "AT",          // optional, but now included
        //   workAlvId: "ALV000336121PW",
        //   incomeFileAlvId: "ALV000093745PI"
        // }
        const metaData = {
            otherId: payload.otherId,             // from error.workNo
            sourceAlvId: payload.sourceAlvId,       // from income file's source ALV ID
            country: payload.country,               // from user-selected dropdown (can be empty)
            workAlvId: payload.workAlvId,           // from the selected work's alvId
            incomeFileAlvId: payload.incomeFileAlvId  // from income file's alvId
        };
    
        // Use a query parameter that reflects the SF102 fix-it type.
        const queryParams = { action: 'fixItSF102' };
    
        try {
            const response = await api.triggerAction(DIR, metaData, queryParams);
    
            if (response.error === -1) {
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERIC_SNACKBAR_FIX_IT_APPLIED')
                });
            }
            // Reset related state
            commit('setSelectedIncome', []);
            commit('setIsAllSelectedIncome', false);
            commit('setSelectedIncomeAction', []);
            await dispatch('fetchIncome');
        } catch (error) {
            console.error('Error in fixItSF102 action:', error);
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ERROR_OCCURRED')
            });
        }
    },

    async fixItC3Error({ commit, dispatch }, payload) {
        const metaData = {
            workIdentifier: payload.workIdentifier,
            sourceAlvId: payload.sourceAlvId,
            workAlvId: payload.workAlvId,
        };
    
        const queryParams = { action: 'fixItC3Error' };
    
        try {
            const response = await api.triggerAction(DIR, metaData, queryParams);
    
            if (response.error === -1) {
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERIC_CAPTION_SUCCESS')
                });
            } else {
                commit('setSnackbar', {
                    type: 'error',
                    msg: i18n.t(response.response.errorMsg) || i18n.t('lang_GENERIC_CAPTION_STATUS_FAILED')
                });
            }
            // Reset related state
            commit('setSelectedIncome', []);
            commit('setIsAllSelectedIncome', false);
            commit('setSelectedIncomeAction', []);
            await dispatch('fetchIncome');
        } catch (error) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_CAPTION_STATUS_FAILED')
            });
        }
    },

    async fixItRecipient({ commit, dispatch }, payload) {
        const metaData = {
            incomeFileAlvId: payload.incomeFileAlvId,
            sourceAlvId: payload.sourceAlvId,
            currentRecipientAlvId: payload.currentRecipientAlvId,
            newRecipientAlvId: payload.newRecipientAlvId,
            workIdentifier: payload.workIdentifier,
            title: payload.title,
            workAlvId: payload.workAlvId,
            incomeErrorListRowAlvId: payload.incomeErrorListRowAlvId,
            incomeRowIds: payload.incomeRowIds,
        };
    
        const queryParams = { action: 'fixItRecipient' };
    
        try {
            const response = await api.triggerAction(DIR, metaData, queryParams);
    
            if (response.error === -1) {
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERIC_CAPTION_SUCCESS')
                });
            } else {
                commit('setSnackbar', {
                    type: 'error',
                    msg: response.errorMsg || i18n.t('lang_GENERIC_CAPTION_STATUS_FAILED')
                });
            }
            // Reset related state
            commit('setSelectedIncome', []);
            commit('setIsAllSelectedIncome', false);
            commit('setSelectedIncomeAction', []);
            commit('setFixItRecipientDetailsNewRecipient', null);
        } catch (error) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_CAPTION_STATUS_FAILED')
            });
        }
    },    

    async fetchAutocompleteFixItYkto({ commit }, input) {
        // limit search results to A-Z Groups and Persons which have all three KTO fields filled
        let response = await api.getAutocompleteSearch('az/persons', input, "ktoExists=true")
        commit('setFixItYktoOptions', response.list)
    },

    async fetchAutocompleteFixItRecipientNewRecipient({ commit }, input) {
        // Search for A-Z Groups and Persons (no KTO restriction)
        let response = await api.getAutocompleteSearch('az/persons', input, "")
        commit('setFixItRecipientNewRecipientOptions', response.list)
    },

    // Search Works for FixIt
    async searchWorksForFixIt({ getters }) {
        let params = 'search=' + getters.getWorksForFixItSearch
        let response = await api.getListData("publishing/works", "1", params)
        return response.list
    },

    // Search Works for FixIt Recipient (by workIdentifier)
    async searchWorksForFixItRecipient(context, workIdentifier) {
        let params = 'search=' + workIdentifier
        let response = await api.getListData("publishing/works", "1", params)
        return response.list
    },

    // Search A-Z for FixIt Recipient (by recipient ID)
    async searchAzForFixItRecipient(context, recipientId) {
        let response = await api.getAutocompleteSearch('az/persons', recipientId, "")
        return response.list
    },

    // KI-Analyse für eine einzelne Fehlerzeile
    async fetchIncomeErrorAiAnalysis({ commit }, alvId) {
        commit('setIncomeErrorAiAnalysisResult', '')
        commit('setIncomeErrorAiAnalysisError', '')
        commit('setShowIncomeErrorAiAnalysisDialog', true)
        commit('setIncomeErrorAiAnalysisLoading', true)

        try {
            const res = await api.getIncomeErrorAiAnalysis(alvId, i18n.locale)

            if (res && res.error === 1) {
                const errorMsg = res.response && res.response.errorMsg
                    ? res.response.errorMsg
                    : 'lang_GENERIC_MESSAGE_ERROR_AI_ANALYSIS_FAILED'
                commit('setIncomeErrorAiAnalysisError', errorMsg)
                return
            }

            if (res && res.error === -1 && res.response) {
                const r = res.response
                const text = r.txt || r.analysis || r.result || r.text || r.message || ''
                commit('setIncomeErrorAiAnalysisResult', text)
                return
            }

            commit('setIncomeErrorAiAnalysisError', 'lang_GENERIC_MESSAGE_ERROR_AI_ANALYSIS_FAILED')
        } catch (e) {
            commit('setIncomeErrorAiAnalysisError', 'lang_GENERIC_MESSAGE_ERROR_AI_ANALYSIS_FAILED')
        } finally {
            commit('setIncomeErrorAiAnalysisLoading', false)
        }
    },

}

export default {
    state, getters, actions, mutations
}
